<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LeadNetworkAPI from 'dashboard/api/leadNetwork';

const props = defineProps({
  event: { type: Object, required: true },
  networks: { type: Array, default: () => [] },
});

const emit = defineEmits(['close', 'sold']);

const { t } = useI18n();
const networkId = ref(props.networks[0]?.network?.id || '');
const sellerConsentGiven = ref(false);
const sellerConsentBasis = ref('verbal_in_thread');
const isSubmitting = ref(false);
const error = ref('');

const submit = async () => {
  error.value = '';
  if (!sellerConsentGiven.value) {
    error.value = t('LEAD_NETWORK.SELL.CONSENT_REQUIRED');
    return;
  }
  isSubmitting.value = true;
  try {
    await LeadNetworkAPI.sellEvent(props.event.id, {
      network_id: networkId.value,
      seller_consent_given: true,
      seller_consent_basis: sellerConsentBasis.value,
    });
    emit('sold');
    emit('close');
  } catch (e) {
    error.value = e.response?.data?.error || t('LEAD_NETWORK.SELL.ERROR');
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div
      class="bg-n-solid-1 rounded-xl p-6 w-full max-w-md flex flex-col gap-4"
    >
      <h2 class="text-lg font-semibold">{{ t('LEAD_NETWORK.SELL.TITLE') }}</h2>
      <select v-model="networkId" class="border rounded-lg p-2">
        <option v-for="m in networks" :key="m.id" :value="m.network.id">
          {{ m.network.name }}
        </option>
      </select>
      <label class="flex items-start gap-2 text-sm">
        <input v-model="sellerConsentGiven" type="checkbox" />
        {{ t('LEAD_NETWORK.SELL.CONSENT_LABEL') }}
      </label>
      <select
        v-model="sellerConsentBasis"
        class="border rounded-lg p-2 text-sm"
      >
        <option value="verbal_in_thread">
          {{ t('LEAD_NETWORK.SELL.BASIS.VERBAL') }}
        </option>
        <option value="written_confirmation">
          {{ t('LEAD_NETWORK.SELL.BASIS.WRITTEN') }}
        </option>
        <option value="other">{{ t('LEAD_NETWORK.SELL.BASIS.OTHER') }}</option>
      </select>
      <p v-if="error" class="text-sm text-red-600">{{ error }}</p>
      <div class="flex justify-end gap-2">
        <button class="px-3 py-1.5 rounded-lg" @click="emit('close')">
          {{ t('LEAD_NETWORK.SELL.CANCEL') }}
        </button>
        <button
          class="px-3 py-1.5 rounded-lg bg-n-brand text-white"
          :disabled="isSubmitting"
          @click="submit"
        >
          {{ t('LEAD_NETWORK.SELL.SUBMIT') }}
        </button>
      </div>
    </div>
  </div>
</template>
